export * from './copyright/copyright.component';
export * from './legal-links/legal-links.component';
